import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { locale, addLocale } from 'primereact/api';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import SeleccionUsuario from '../components/SeleccionUsuario';
import SeleccionCodigos from '../components/SeleccionCodigos';
import SeleccionChipsHembras from '../components/SeleccionChipsHembras';
import SeleccionTipoDocumento from '../components/SeleccionTipoDocumento';
import SeleccionFormularios from '../components/SeleccionFormularios';
import SeleccionConsecutivoServicio from '../components/SeleccionConsecutivoServicio';
import SeleccionInseminador from '../components/SeleccionInseminador';
import Lateral from '../components/Lateral';
import Ayuda from '../components/Ayuda'

const FormularioA02 = () => {
    let emptyProduct = {
        TID_TERCERO: '',
        NID_TERCERO: '',
        CONSECUTIVO: '',
        COD_ESPECIE: '',
        FECHA_SOLICITUD: '',
        FECHA_SERVICIO: '',
        CHIP_MACHO: '',
        CHIP_HEMBRA: '',
        OBSERVACIONES: '',
        RAZA_MACHO: '',
        TID_INSEMINADOR: '',
        NID_INSEMINADOR: '',
        CANTIDAD_PAJILLAS: '',
        SOPORTE: '',
        TIPO_INSEMINACION: '',
        NOMBRE_MACHO: '',
        CONSECUTIVO_SERVICIO: '',
        FORMULARIO: '',
        NOM_PAIS: '',
        NOM_ESPECIE: ''
    };
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['Enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    locale('es');
    const [productDialog, setProductDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [reloadUsuarios, setReloadUsuarios] = useState(true)
    const [usuariosAnco, setUsuariosAnco] = useState([])
    const [muestraCodigos, setMuestraCodigos] = useState(false)
    const [nidPropietario, setNidPropietario] = useState(0)
    const [fechaServicio, setFechaServicio] = useState('')
    const [fechaSolicitud, setFechaSolicitud] = useState('')
    const [codigoEspecie, setCodigoEspecie] = useState('')
    const [muestraRaza, setMuestraRaza] = useState(false)
    const [nomRaza, setNomRaza] = useState('')
    const [codigoRaza, setCodigoRaza] = useState(0)
    const [parentesco, setParentesco] = useState('')
    const [muestraParentesco, setMuestraParentesco] = useState(false)
    const [reloadPrefijo, setReloadPrefijo] = useState(false)
    const [prefijo, setPrefijo] = useState('')
    const [enviar, setEnviar] = useState(false)
    const [muestraConsecutivo, setMuestraConsecutivo] = useState(false)
    const [consecutivoServicio, setConsecutivoServicio] = useState(0)
    const [reloadDatosConsecutivo, setReloadDatosConsecutivo] = useState(false)
    const [mdatosConsecutivo, setMdatosConsecutivo] = useState([])
    const [codigo, setCodigo] = useState(0)
    const [inputNumberValue, setInputNumberValue] = useState(null);
    const [pajillasPendientes, setPajillasPendientes] = useState(false)
    const [muestraUsuario, setMuestraUsuario] = useState(false)
    const [pendientes, setPendientes] = useState(0)
    const [minimo, setMinimo] = useState(0)
    const [file, setFile] = useState(null)
    const [tidPropietario, setTidPropietario] = useState('')
    const [mostrarHembras, setMostrarHembras] = useState(false)
    const toast = useRef(null);
    const dt = useRef(null);
    const [ayuda, setAyuda] = useState(false)    
    const APIFORMULARIOA02 = 'https://www.ancogenecop.com/APIANCO/controllers/formularioA02.php?op='


    useEffect(() => {
        if (reloadUsuarios) {
            const recarga = async () => {
                setUsuariosAnco([])
                const data = new FormData();
                if(localStorage.getItem('administrador')==1){
                    data.append('NID_TERCERO','ADMINANCO')
                    console.log(1)
                    if(nidPropietario==''){
                        data.append('NID_TERCERO','ADMINANCO')
                        console.log(2)
                    }else{
                        data.append('NID_TERCERO',nidPropietario)
                        
                    }
                  }else{
                    data.append('NID_TERCERO',localStorage.getItem('nid_propietario'))
                  }
                  
                await fetch(APIFORMULARIOA02 + 'formulariosA02', {
                    method: 'POST',
                    header: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                    body: data
                }).then((response) => response.json())
                    .then((response) => {
                        if (response != []) {
                            setUsuariosAnco(response)
                            setReloadUsuarios(false)
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
            recarga()
        }
    }, [reloadUsuarios])

    useEffect(() => {
        if (reloadDatosConsecutivo) {
            setReloadDatosConsecutivo(false)
            const recarga = async (consecutivoServicio,codigo) => {
                setUsuariosAnco([])
                setPendientes(0)
                setMinimo(0)
                const data = new FormData();
                data.append("CONSECUTIVO", consecutivoServicio)
                data.append("CODIGO", codigo)
                await fetch(APIFORMULARIOA02 + 'datosConsecutivoServicio', {
                    method: 'POST',
                    header: {

                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                    body: data
                }).then((response) => response.json())
                    .then((response) => {
                        if (response != []) {
                             setMdatosConsecutivo(response)
                             setPajillasPendientes(true)
                             setReloadUsuarios(true)
                             setPendientes(parseInt(response[0].PENDIENTES))
                             setNomRaza(response[0].RAZA)
                             if(parseFloat(response[0].PENDIENTES)>0){
                                setMinimo(1)
                             }

                            product.NOMBRE_MACHO =response[0].NOMBRE_DEL_MACHO
                            product.NOM_ESPECIE =response[0].NOM_ESPECIE
                            product.COD_ESPECIE = response[0].ESPECIE
                            product.CHIP_MACHO = response[0].CRG_MACHO
                            product.RAZA_MACHO = response[0].RAZA
                            product.NOM_PAIS = response[0].NOMBRE
                            product.PAIS = response[0].PAIS_ORIGEN
                            setMostrarHembras(true)
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
            recarga(consecutivoServicio,codigo)
        }
    }, [reloadDatosConsecutivo, consecutivoServicio,codigo])


    const muestraAyuda = () =>{
        setAyuda(true)
    }

    const hideDeleteProductDialog = () => {
        setAyuda(false);
    }

    const deleteProductDialogFooter = (
        <>
            <Button label="Cerrar" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
        </>
    );
    const openNew = () => {
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(false);
        setMuestraCodigos(false)
        setMuestraRaza(false)
        setMuestraParentesco(false)
        setProductDialog(true);
        setMdatosConsecutivo([])
        setEnviar(true)
        setInputNumberValue('')
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
        setMuestraCodigos(false);
    }



    const saveProduct = async () => {
        setSubmitted(true)
        if(product.CONSECUTIVO=='') {
            console.log(1);
            return
         }
         if(product.TID_TERCERO=='') {
         console.log(2)
            return
         }
         if(product.NID_TERCERO=='') {
         console.log(3)
            return
         }
         if(product.FECHA_SOLICITUD=='') {
         console.log(4);
            return
         }
         if(product.FECHA_SERVICIO=='') {
         console.log(5)
            return
         }
         if(product.CHIP_HEMBRA=='') {
         console.log(6)
            return
         }
         if(product.TID_INSEMINADOR=='') {
         console.log(7);
            return
         }
         if(product.NID_INSEMINADOR=='') {
         console.log(8)
            return
         }
         if(product.SOPORTE=='') {
         console.log(9)
            return
         }
         if(product.CONSECUTIVO_SERVICIO=='') {
         console.log(12)
            return
         }
         if(!file){
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo soporte', life: 3000 });
            return;
         }
        const data = new FormData();
        data.append("TID_TERCERO", product.TID_TERCERO)
        data.append("NID_TERCERO", product.NID_TERCERO)
        data.append("CONSECUTIVO", product.CONSECUTIVO)
        data.append("COD_ESPECIE", product.COD_ESPECIE)
        data.append("FECHA_SOLICITUD", product.FECHA_SOLICITUD)
        data.append("FECHA_SERVICIO", product.FECHA_SERVICIO)
        data.append("CHIP_MACHO", product.CHIP_MACHO)
        data.append("CHIP_HEMBRA", product.CHIP_HEMBRA)
        data.append("OBSERVACIONES", product.OBSERVACIONES)
        data.append("RAZA_MACHO", product.RAZA_MACHO)
        data.append("TID_INSEMINADOR", product.TID_INSEMINADOR)
        data.append("NID_INSEMINADOR", product.NID_INSEMINADOR)
        data.append("CANTIDAD_PAJILLAS", inputNumberValue)
        data.append("SOPORTE", product.SOPORTE)
        data.append("TIPO_INSEMINACION", product.TIPO_INSEMINACION)
        data.append("NOMBRE_MACHO", product.NOMBRE_MACHO)
        data.append("CONSECUTIVO_SERVICIO", product.CONSECUTIVO_SERVICIO)
        data.append("FORMULARIO", product.FORMULARIO)
        data.append("CODIGO", 'A02')
        data.append("file",file)
        await fetch(APIFORMULARIOA02 + 'ingresarInseminacion', {
            method: 'POST',
            header: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: data
        }).then((response) => response.json())
            .then((response) => {
                if (response == 1) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'El Registro ha sido Ingresado o Actualizado', life: 3000 });
                    setSubmitted(false);
                    setProductDialog(false);
                    setProduct(emptyProduct);
                    setReloadUsuarios(true)
                } else if(response==100) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'El tipo de archivo seleccionado no es permitido, verifique por favor...', life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'El Registro no pudo ser Ingresaro o Actualizado', life: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const editProduct = (product) => {
    //console.log(product)
        setProduct({ ...product });
        setProductDialog(true);
        setMuestraCodigos(true)
        setMuestraRaza(true)
        setMuestraParentesco(true)
        setConsecutivoServicio(product.CONSECUTIVO_SERVICIO)
        setCodigo(product.FORMULARIO)
    //    setNidPropietario(product.NID_TERCERO)
        setCodigoRaza(product.COD_ESPECIE)
        setParentesco(product.PARENTESCO)
        setFechaServicio(product.FECHA_SERVICIO)
        setFechaSolicitud(product.FECHA_SOLICITUD)
        setReloadDatosConsecutivo(true)
        setEnviar(true)
    }

    const confirmDeleteProduct = (product) => {
        setReloadUsuarios(true)
        setProduct({ ...product });
        setMuestraUsuario(true)
        setProductDialog(true);
        setMuestraCodigos(true)
        setMuestraRaza(true)
        setMuestraConsecutivo(true)
        setReloadDatosConsecutivo(true)
        setEnviar(false)
        setNidPropietario(product.NID_TERCERO)
        setCodigoRaza(product.COD_ESPECIE)
        setParentesco(product.PARENTESCO)
        setFechaServicio(product.FECHA_SERVICIO)
        setFechaSolicitud(product.FECHA_SOLICITUD)
        setCodigoEspecie(product.COD_ESPECIE)
        setPrefijo(product.PREFIJO_SOLICITANTE)
        setConsecutivoServicio(product.CONSECUTIVO_SERVICIO)
        setInputNumberValue(product.CANTIDAD_PAJILLAS)
        setCodigo(product.FORMULARIO)

    }


    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);
    }


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Adicionar" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {/* <FileUpload mode="basic" accept="image/*" maxFileSize={1000000} label="Import" chooseLabel="Import" className="mr-2 inline-block" /> */}
                <Button label="Ayuda" icon="pi pi-question-circle" className="p-button-help" onClick={() => muestraAyuda()} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
            {localStorage.getItem('administrador')==1 &&
             <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
            } 
                <Button icon="pi pi-search" className="p-button-rounded p-button-warning mt-2" onClick={() => confirmDeleteProduct(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">INSEMINACION ARTIFICIAL FORMULARIO A02</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="Buscar" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const headerDatos = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">INFORMACION CONTENIDA EN EL TIPO DE FORMULARIO Y EL CONSECUTIVO DE SERVICIO</h5>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label={enviar ? "Cancelar" : "Cerrar"} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            {enviar &&
                <Button label="Enviar" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
            }

        </>
    );

    const handleplanta = async (dato, opc,opcion) => {
        setSubmitted(false)
        if (opc == 1) {
            setNidPropietario(dato)
            setMuestraCodigos(false)
            product.NID_TERCERO = dato
        } else if (opc == 2) {
            product.CONSECUTIVO = dato
        } else if (opc == 3) {
            setCodigoEspecie(dato)
            product.COD_ESPECIE = dato
        } else if (opc == 4) {
            setCodigoRaza(dato)
            setMuestraRaza(true)
            product.RAZA_MACHO = dato
        }
        else if (opc == 5) {
            product.CHIP_MACHO = dato
        } else if (opc == 6) {
            setParentesco(dato)
            setMuestraParentesco(true)
            product.PARENTESCO = dato
        } else if (opc == 7) {
            product.RAZA_MESTIZAJE = dato
        } else if (opc == 8) {
            product.CHIP_HEMBRA = dato
        } else if (opc == 9) {
            setMuestraUsuario(true)
            setTidPropietario(dato)
            product.TID_TERCERO = dato
        } else if (opc == 10) {
            setConsecutivoServicio(true)
            setCodigo(dato)
            product.FORMULARIO = dato
        } else if (opc == 11) {
            setReloadDatosConsecutivo(true)
            setConsecutivoServicio(dato)
            product.CONSECUTIVO_SERVICIO = dato
        } else if (opc == 12) {
            product.NID_INSEMINADOR = dato
        }
        else if (opc == 13) {
            product.TID_INSEMINADOR = dato
        }
        else if (opc == 1000) {
            setNidPropietario(0)
            setMuestraCodigos(false)
        }
    }

    const handleChange = (e) => {
        setFile(e.target.files[0]);
        product.SOPORTE=e.target.files[0].name;
      };

    function calcularEdad(fecha, opcion) {

        if (opcion == 1) {
            setFechaSolicitud(new Date(fecha).toISOString().slice(0, 10))
            product.FECHA_SOLICITUD = new Date(fecha).toISOString().slice(0, 10)
        } else if (opcion == 2) {
            setFechaServicio(new Date(fecha).toISOString().slice(0, 10))
            product.FECHA_SERVICIO = new Date(fecha).toISOString().slice(0, 10)
        }
    }

    const imageBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Image</span>
                <img src={`${rowData.SOPORTE}`} alt={rowData.SOPORTE} className="shadow-2" width="100"
                onClick={()=>onLoadingClick(rowData.SOPORTE)}/>
            </>
        )
    }

    const onLoadingClick = (soporte) => {
        window.open(soporte, "_blank")
    }

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                    <div className="formgrid grid">
                        <div className="field col-12">
                    <DataTable ref={dt} value={usuariosAnco} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="No existen registros." header={header} responsiveLayout="scroll">
                        <Column body={actionBodyTemplate}></Column>
                        {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem'}}></Column> */}
                        <Column field="descripcion" header="TID_TERCERO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="NID_TERCERO" header="NID_TERCERO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="NOMBRE" header="NOMBRE" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="CONSECUTIVO" header="CONSECUTIVO" sortable headerStyle={{ width: '14%', minWidth: '8rem' }}></Column>
                        <Column field="NOMBREFORMULARIO" header="FORMULARIO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="CONSECUTIVO_SERVICIO" header="CONSECUTIVO_SERVICIO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="FECHA_SOLICITUD" header="FECHA_SOLICITUD" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="FECHA_SERVICIO" header="FECHA_SERVICIO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="COD_ESPECIE" header="COD_ESPECIE" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="NOMBRE_MACHO" header="NOMBRE_MACHO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="RAZA_MACHO" header="RAZA_MACHO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="CHIP_MACHO" header="CHIP_MACHO" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="CHIP_HEMBRA" header="CHIP_HEMBRA" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="PAIS" header="PAIS" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="CANTIDAD_PAJILLAS" header="CANTIDAD_PAJILLAS" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="DESCRIP" header="TID_INSEMINADOR" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="NID_INSEMINADOR" header="NID_INSEMINADOR" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="NOMBREINSEMINADOR" header="NOMBRE INSEMINADOR" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column header="DOC. SOPORTE" body={imageBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="OBSERVACIONES" header="OBSERVACIONES" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                    </DataTable>
                    </div>
                    {/* <div className="field col-3"><Lateral/>

                    </div> */}
                    </div>
                    <Dialog visible={productDialog} style={{ width: '850px' }} header={enviar ? "Adicionar  Inseminación Artificial" : "Consultando Inseminación Artificial"} modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        {/* {product.image && <img src={`assets/demo/images/product/${product.image}`} alt={product.image} width="150" className="mt-0 mx-auto mb-5 block shadow-2" />} */}
                        <div className="formgrid grid">
                            <div className="field col-6">
                                <label htmlFor="name">Tipo Documento</label>
                                <SeleccionTipoDocumento handleplanta={handleplanta} opcion={9} TIDPROPIETARIO={product.TID_TERCERO}
                                required/>
                                {submitted && !product.TID_TERCERO && <small className="p-invalid"
                                style={{
                                    color: 'red',
                                }}>El tipo de documento es requerido.</small>}
                            </div>
                            {/* {muestraUsuario && */}
                            <div className="field col">
                                <label htmlFor="name">Propietario</label>
                                <SeleccionUsuario codigo={'A02'} handleplanta={handleplanta}
                                required
                                NOMPROPIETARIO={product.NOMBRE}
                                 tidPropietario={tidPropietario}
                                />
                                {submitted && !product.NID_TERCERO && <small className="p-invalid"
                                style={{
                                    color: 'red',
                                }}>Nombre del usuario es requerido.</small>}
                            </div>
                            {/* } */}
                            <hr />
                        </div>
                        <div className="formgrid grid">
                            {/* {muestraCodigos && nidPropietario > 0 && */}
                                <>
                                    <div className="field col">
                                        <label htmlFor="name">Consecutivo</label>
                                        <SeleccionCodigos NID_PROPIETARIO={nidPropietario}
                                            codigo={'A02'} CONSECUTIVO={product.CONSECUTIVO} handleplanta={handleplanta} />
                                        {submitted && !product.CONSECUTIVO && <small className="p-invalid " style={{
                                          color: 'red',
                                        }}>El consecutivo es requerido.</small>}
                                    </div>
                                    <div className="field col">
                                        <label htmlFor="name">Tipo de Formulario</label>
                                        <SeleccionFormularios
                                        formulario={'A10'} formulario1={'A11'}
                                        formulario2={''} formulario3={''}
                                        codigo={'A02'}
                                        FORMULARIO={product.NOMBREFORMULARIO}
                                        handleplanta={handleplanta} />
                                        {submitted && !product.FORMULARIO && <small className="p-invalid"
                                        style={{
                                        color: 'red',
                                        }}>El tipo de formulario es requerido.</small>}
                                    </div>
                                    <div className="field col">
                                        <label htmlFor="name">Consecutivo del Servicio</label>
                                        <SeleccionConsecutivoServicio codigo={codigo} NID_PROPIETARIO={nidPropietario}
                                        CONSECUTIVO_SERVICIO={product.CONSECUTIVO_SERVICIO}
                                        handleplanta={handleplanta} />
                                        {submitted && !product.CONSECUTIVO_SERVICIO && <small className="p-invalid"
                                        style={{
                                          color: 'red',
                                        }}>El consecutivo de servicio es requerido.</small>}
                                    </div>

                                </>
                            {/* } */}
                        </div>
                        <hr />
                        {/* {muestraConsecutivo && */}
                            <>
                                <div className="formgrid grid">
                                <DataTable ref={dt} value={mdatosConsecutivo} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                                    dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                                    emptyMessage="No existen registros." header={headerDatos} responsiveLayout="scroll">
                                    <Column field="NOM_ESPECIE" header="COD_ESPECIE" sortable ></Column>
                                    <Column field="NOMBRE_DEL_MACHO" header="NOMBRE_MACHO" sortable ></Column>
                                    <Column field="CRG_MACHO" header="CRG_MACHO" sortable ></Column>
                                    <Column field="RAZA" header="RAZA_MACHO" sortable ></Column>
                                    <Column field="NOMBRE" header="PAIS" sortable ></Column>
                                </DataTable>
                                <hr/>
                                </div>
                                <hr />
                                <div className="grid">
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="dirección">Fecha de Solicitud: {fechaSolicitud}</label>
                                        <Calendar showIcon showButtonBar value={fechaSolicitud}
                                            dateFormat="yy-mm-dd" monthNavigator={true} yearNavigator={true}
                                            yearRange="1960:2060" required
                                            readOnlyInput={true}
                                            locale='es'
                                            onChange={(e) => calcularEdad(e.value, 1)}></Calendar>
                                        {submitted && !product.FECHA_SOLICITUD && <small className="p-invalid"
                                        style={{
                                        color: 'red',
                                        }}>la fecha de solicitud es requerida.</small>}
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="dirección">Fecha de Servicio: {fechaServicio}</label>
                                        <Calendar showIcon showButtonBar value={fechaServicio}
                                            dateFormat="yy-mm-dd" monthNavigator={true}
                                            locale='es'
                                            yearNavigator={true}
                                            yearRange="1960:2060" required
                                            onChange={(e) => calcularEdad(e.value, 2)}></Calendar>
                                        {submitted && !product.FECHA_SERVICIO && <small className="p-invalid"
                                        style={{
                                        color: 'red',
                                        }}>La fecha de servicio es requerida.</small>}
                                    </div>
                                </div>
                                <hr />
                                <div className="formgrid grid">
                                {mostrarHembras &&
                                    <div className="field col col-6">
                                        <label htmlFor="name">Crg. Hembra</label>
                                        <SeleccionChipsHembras COD_ESPECIE={mdatosConsecutivo["ESPECIE"]}
                                            NID_PROPIETARIO={nidPropietario}
                                            RAZA={nomRaza}
                                            SEXO='H'
                                            PARENTESCO={''}
                                            CHIPMACHO={''}
                                            CHIP_HEMBRA={product.CHIP_HEMBRA}
                                            CONSECUTIVO={'1'}
                                            codigo='A02'
                                            handleplanta={handleplanta} />
                                        {submitted && !product.CHIP_HEMBRA && <small className="p-invalid"
                                        style={{
                                          color: 'red',
                                        }}>El número de chip de la hembra es requerido.</small>}
                                    </div>
                                }
                                    {pajillasPendientes &&
                                        <div className="field col">
                                            <label htmlFor="name">Cantidad de Pajillas Disponibles:{pendientes}</label>
                                            <InputNumber value={inputNumberValue} max={pendientes} min={minimo} onValueChange={(e) => setInputNumberValue(e.value)} showButtons mode="decimal"></InputNumber>
                                            {submitted && (!inputNumberValue || inputNumberValue > pendientes) && <small className="p-invalid"
                                            style={{
                                              color: 'red',
                                            }}>La cantidad de pajillas no es correcta.</small>}
                                        </div>
                                      }
                                </div>
                                <hr />
                                <div className="formgrid grid">
                                    <div className="field col">
                                        <label htmlFor="name">Tipo Documento</label>
                                        <SeleccionTipoDocumento handleplanta={handleplanta} opcion={13} TIDPROPIETARIO={product.TID_INSEMINADOR}/>
                                        {submitted && !product.TID_INSEMINADOR && <small className="p-invalid"
                                        style={{
                                          color: 'red',
                                        }}>El tipo de documento es requerido.</small>}
                                    </div>

                                    <div className="field col">
                                        <label htmlFor="name">Inseminador</label>
                                        <SeleccionInseminador codigo={'A'} handleplanta={handleplanta} NOMBREINSEMINADOR={product.NOMBREINSEMINADOR} />
                                        {submitted && !product.NID_INSEMINADOR && <small className="p-invalid"
                                        style={{
                                          color: 'red',
                                        }}>Nombre del inseminador es requerido.</small>}
                                    </div>
                                    <hr />
                                </div>
                                <div className="formgrid grid">
                                    <label htmlFor="dirección">Documentos Soporte</label>

                                    <div className="field col">
                                        <input type="file" className="custom-file-input" id="customFileLang" lang="es"
                                            accept="jpg/*"
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {submitted && !product.SOPORTE && <small className="p-invalid"
                                    style={{
                                    color: 'red',
                                    }}>El documento soporte es obligatorio.</small>}
                                    {!enviar &&
                                    <div className="field col">
                                        <img src={`${product.SOPORTE}`} alt={product.SOPORTE} className="shadow-2" width="100"
                                        onClick={()=>onLoadingClick(product.SOPORTE)}/>
                                    </div>
                                    }
                                </div>
                                <div className="formgrid grid">
                                </div>
                                <div className="field">
                                    <label htmlFor="description">Observaciones</label>
                                    <InputTextarea id="observaciones" value={product.OBSERVACIONES} onChange={(e) => onInputChange(e, 'OBSERVACIONES')} required rows={3} cols={20} />
                                </div>
                            </>
                        {/* } */}

                    </Dialog>

                    <Dialog visible={ayuda} style={{ width: '900px' }} header="Ayuda Inseminación Artificial Formulario A02" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                        <Ayuda formulario={'A02'} />                    
                    </Dialog>

                    {/* <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {product && <span>Are you sure you want to delete the selected products?</span>}
                        </div>
                    </Dialog> */}
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(FormularioA02, comparisonFn);
